import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import theme from "./theme";
import { UiAuthProvider } from "../context/UiAuthContext";
import router from "../pages/routes";

import "react-toastify/dist/ReactToastify.css";
import "dayjs/locale/pt-br";

function App(): React.JSX.Element {
  return (
    <LocalizationProvider adapterLocale="pt-br" dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        <ToastContainer />
        <CssBaseline />
        <UiAuthProvider>
          <RouterProvider router={router} />
        </UiAuthProvider>
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
